import {
  RECORD_RECENTLY_VIEWED,
  GET_RECENTLY_VIEWED_LIST,
  GET_RECENTLY_VIEWED_LIST_SUCCESS,
  GET_RECENTLY_VIEWED_LIST_FAIL,
} from "./actionType";

// Record a view event. payload: { ObjectTable, ObjectId, Title, UrlLink }
export const recordRecentlyViewed = (payload) => ({
  type: RECORD_RECENTLY_VIEWED,
  payload,
});

// Get the recently viewed list
export const getRecentlyViewedList = () => ({
  type: GET_RECENTLY_VIEWED_LIST,
});

export const getRecentlyViewedListSuccess = (response) => ({
  type: GET_RECENTLY_VIEWED_LIST_SUCCESS,
  payload: response,
});

export const getRecentlyViewedListFail = (error) => ({
  type: GET_RECENTLY_VIEWED_LIST_FAIL,
  payload: error,
});
